/**
 * index.js
 *
 * This is the main JavaScript entry point file that Webpack will
 * build from. If you want a piece of JavaScript in your bundle,
 * you will need to include it here.
 *
 * As we are not using jQuery, your master page / html page / layout
 * page will need to initiate your JavaScript bundle. We can use the
 * `domready` package as a light-weight version of $document.ready().
 *
 * You might initiate your Javascript like so:
 * <script>
 *  domReady(function() {
 *    new App()
 *  })
 * </script>
 */

/* eslint-disable no-new */
/* eslint-disable no-unused-vars */

// We import assets and styles to prompt webpack to bundle them
import '@asset-manifest'
import './styles/styles.scss'
import '@polyfills'

import domReady from 'domready'
import Accordion from '@components/Accordion'
import AddToCalendar from '@components/AddToCalendar'
import ArticleCardListingWidget from '@components/ArticleCardListingWidget'
import FilterBar from '@components/FilterBar'
import MainNav from '@components/MainNav'
import NewsletterForm from '@components/NewsletterForm'
import ReciteMe from '@components/ReciteMe'
import SplitHeader from '@components/SplitHeader'

class App {
  constructor() {
    if (document.querySelector('.main-navigation') != null) new MainNav()
    if (document.querySelector('.js-button-a11y-tools') != null) new ReciteMe()
    if (document.querySelector('.accordion') != null) new Accordion()
    if (document.querySelector('.article-card-listing-widget') != null)
      new ArticleCardListingWidget()
    if (document.querySelector('.js-filter-bar') != null) new FilterBar()
    if (document.querySelector('.js-event-add-to-calendar') != null) new AddToCalendar()
    if (
      document.querySelector(
        '.js-survey, .js-survey-verification-push, .js-survey-verification-state, .js-survey-demographics'
      ) != null
    ) {
      void import(/* webpackChunkName: "survey" */ '@components/Survey/bootstrap').then(
        ({ default: bootstrapSurvey }) => {
          bootstrapSurvey()
        }
      )
    }
    if (document.querySelector('.js-newsletter-form-widget') != null) new NewsletterForm()

    if (document.body.dataset.previewMode === 'true') {
      void import(/* webpackChunkName: "web-spotlight" */ '@components/WebSpotlight').then(
        ({ default: WebSpotlight }) => {
          new WebSpotlight()
        }
      )
    }

    const splitHeaders = document.querySelectorAll('.hb-title[data-words-per-line]')
    splitHeaders.forEach((header) => {
      const wordsPerLine = Number.parseInt(header.getAttribute('data-words-per-line') || '', 10)
      SplitHeader(
        header,
        Number.isFinite(wordsPerLine) && wordsPerLine > 0 ? wordsPerLine : undefined
      )
    })
  }
}

domReady(() => {
  new App()
})

window.domReady = domReady
window.App = App
